import { render, staticRenderFns } from "./tableData.vue?vue&type=template&id=25fe4e58&scoped=true&"
import script from "./tableData.vue?vue&type=script&lang=js&"
export * from "./tableData.vue?vue&type=script&lang=js&"
import style0 from "./tableData.vue?vue&type=style&index=0&id=25fe4e58&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25fe4e58",
  null
  
)

export default component.exports